export const CSCA_REVIEW_SUBJECTS = [
  { level: 1, label: '文科中文' }, { level: 2, label: '理科中文' },
  { level: 3, label: '数学' }, { level: 4, label: '物理' }, { level: 5, label: '化学' },
];
export const CSCA_LANGUAGE_REVIEW_TYPES = ['识解汉字', '选词填空', '近反义词', '选词成段', '补全语句', '阅读理解'];
export const CSCA_MATH_REVIEW_TYPES = ['集合', '不等式', '函数', '指数与对数', '三角函数', '数列', '平面解析几何', '圆锥曲线', '平面向量', '复数', '概率与统计'];
export function cscaReviewTypes(level: number, actualTypes: string[] = []) {
  const configured = level === 1 || level === 2 ? CSCA_LANGUAGE_REVIEW_TYPES : level === 3 ? CSCA_MATH_REVIEW_TYPES : [];
  if (level === 1 || level === 2) return configured;
  return [...configured, ...Array.from(new Set(actualTypes.filter(x => x && !configured.includes(x))))];
}
